<template>
   <b-container fluid id="login">
      <b-row class="h-100">
         <b-col align-self="center" :md="modal ? 12 : 6">
            <div class="text-center">
               <img class="brand d-none" src="@/assets/img/logo-pedale.png" @click="goHome()" alt="logo-pedale">

            </div>

            <section class="banner-mobile bg-cover d-block d-md-none position-relative mb-4" :style="{ background: `url(${bgLoginMobile})` }">
               <div style="z-index: 1" class="position-relative">
                  <h1 class="h2 font-weight-bold text-white text-center">Faça o login em sua conta Pedale</h1>
                  <p style="font-weight: 500;" class="text-white text-center lead">Entre com seus dados para acessar a sua conta.</p>
               </div>
               <div class="mask"></div>
               <b-container class="h-100 calendar-home-wrap">
                  <b-row no-gutters align-v="center" class="h-100">
                     <b-col md="8" lg="6" xl="5">
                        <!--busca-->

                     </b-col>
                  </b-row>
               </b-container>
            </section>

            <b-row align-h="center">
               <b-col :lg="modal ? 12 : 8" :xl="modal ? 12 : 6">
                  <div class="text-center my-4 mb-md-4 d-none d-md-block">
                     <div>
                        <h4 v-if="!modal">Acesse a sua conta</h4>
                        <p v-if="0" class="text-muted">Escolha como você quer efetuar o login:</p>
                     </div>
                  </div>

                  <div v-if="false" class="text-center mb-2 mb-md-4">
                     <el-button type="default" class="d-block w-100 font-weight-bold btn-icon btn-facebook" round>
                        <v-icon class="icon-facebook" name="brands/facebook-f"></v-icon>
                        ENTRAR COM O FACEBOOK
                     </el-button>

                     <div class="text-muted mt-2 mt-md-3" style="font-size: .8rem">-- OU --</div>
                  </div>
                  <!--===== Form Login =====-->
                  <el-form
                     id="loginForm"
                     :model="user"
                     status-icon
                     :rules="userRules"
                     ref="loginForm"
                     class="login-form">

                     <el-form-item label="E-mail" prop="email">
                        <el-input
                           type="mail"
                           v-model.trim="user.email"
                           autocomplete="off"
                           placeholder="Digite seu e-mail"
                        >

                           <template v-if="false" slot="prepend">
                              <v-icon name="user"></v-icon>
                           </template>

                        </el-input>

                     </el-form-item>
                     <el-form-item label="Senha" prop="password">
                        <el-input
                           @keyup.enter.native="submitLoginForm('loginForm')"
                           type="password"
                           v-model.trim="user.password"
                           autocomplete="off"
                           placeholder="Digite seu senha">

                           <template v-if="false" slot="prepend">
                              <v-icon name="lock"></v-icon>
                           </template>

                        </el-input>
                     </el-form-item>

                     <el-form-item>
                        <el-button
                           type="primary"
                           class="mt-1 mt-md-3 d-block w-100 font-weight-bold"
                           round
                           @click="submitLoginForm('loginForm')"
                           :loading="loading"
                        >
                           ENTRAR
                        </el-button>
                     </el-form-item>
                  </el-form>
                  <!--===== End Form Login =====-->

                  <div v-if="!modal" class="text-center mb-3 register-btn">
                     <router-link to="/recuperar-senha">Esqueceu a senha?</router-link>
                     <hr class="mt-1 pb-2 pb-sm-0 mb-2 mt-md-3 mb-md-3">
                     <div class="font-strong">Ainda não tem uma conta?</div>
                     <el-button
                        type="primary"
                        class="bg-transparent text-primary bordered mt-3 mt-md-3 mb-5 d-block w-100 m-auto font-weight-bold btn-login-register"
                        round
                        @click="() => this.$router.push({name: 'register'})"
                        :loading="loading"
                     >
                        CADASTRE-SE
                     </el-button>
                  </div>

               </b-col>
            </b-row>
         </b-col>

         <b-col v-if="!modal" class=" login-cover order-first order-md-2 bg-fade-image-wrap" style="overflow: hidden;">
            <div :style="{backgroundImage : `url(${bgLogin})`}" class="bg-fade-image bg-cover bg-center bg-primary ">

            </div>
            <div class="mask"></div>
            <router-link to="/" class="back-to-site">← Voltar ao site</router-link>
         </b-col>
      </b-row>
   </b-container>

</template>

<script>
import bgLoginMobile from '@/assets/img/login-mobile.jpg';
import bgLogin from '@/assets/img/login.jpg';
import User from '../models/Login';
import {metaTags} from "@/helpers";
import bgHome from '@/assets/img/banner-home.jpg';
export default {
   name: 'Login',
   metaInfo: metaTags(`Login`),
   props: {
      modal: {
         type: Boolean,
         default: false
      },
      namespace: {
         type: String,
         default: ''
      }
   },
   data() {
      return {
         bgHome,
         baseUrl: process.env.VUE_APP_BASE_URL,
         apiV1: process.env.VUE_APP_API_V1,
         user: new User('', ''),
         loading: false,
         userRules: {
            email: [
               {required: true, message: 'Por favor, preencha seu e-mail', trigger: 'blur'},
               {
                  type: 'email',
                  message: 'Por favor, digite um endereço de e-mail válido',
                  trigger: ['blur']
               }
            ],
            password: [
               {required: true, message: 'Por favor, digite sua senha', trigger: 'blur'}
            ],
         },
         bgLogin,
         bgLoginMobile,
         pushToken: null
      };
   },

   created() {
      if (this.loggedIn && !this.namespace) {
         this.$router.push('/painel/inicio')
      }
   },

   mounted() {
      this.getPushToken();
   },
   methods: {

      // Obtém o token push do localStorage
      getPushToken() {
         this.pushToken = JSON.parse(localStorage.getItem('pushToken'))
      },

      submitLoginForm(form) {
         this.$refs[form].validate((valid) => {

            this.loading = true;

            if (valid) {
               this.$store.dispatch('auth/login', {
                  user: this.user,
                  resources: {
                   pushToken: this.pushToken
                  }})
                  .then(() => {

                     this.$message({
                        message: 'Login efetuado com sucesso!',
                        type: 'success'
                     });

                     this.loading = false;

                     if (!this.namespace) {
                        this.$router.push('/painel/inicio');
                     }

                     if (this.namespace === 'bike') {
                        this.$emit('loginDone', true)
                        //this.$router.push('/checkout')
                        return false
                     }

                     if (this.namespace === 'bike/chat') {
                        return false
                     }

                  })
                  .catch(() => {
                     this.loading = false;
                  })
            } else {
               this.$message.error('Preencha os campos corretamente!');
               this.loading = false;
               return false;
            }
         });
      },

      resetForm(formName) {
         this.$refs[formName].resetFields();
      },

      goHome() {
         this.$router.push('/');
         this.menuOpen = false;
      },

      lastViewedBike() {
         return JSON.parse(localStorage.getItem('bike/lastViewed'));
      }
   },

   computed: {
      loggedIn() {
         return this.$store.state.auth.status.loggedIn;
      }
   },

   watch: {}
}

</script>

<style lang="scss">

@media (max-width: 767.98px) {

   .login {
      .banner-mobile {
         background: #1f443d;
         padding: 2rem 1.5rem;

         p {
            margin-bottom: 0;
         }

         .mask {
            background-color: rgba(31, 68, 61, 0.76);
         }
      }
   }


   #loginForm {
      padding: 0 5px;

      label {
         font-weight: bold;
      }
   }

   .login-cover {
      display: none;
   }

   .register-btn {
      padding: 0 20px;
      a {
         margin-top: -5px !important;
         margin-bottom: 10px !important;
         display: block;
      }
      button {
         margin-top: 10px !important;
      }

   }
}

</style>
